<template>
  <div
    class="row row-inside separator-int"
    v-if="annonce"
  >
    <div class="flex md1">
      <span :class="partenaire_name_color">
        {{ annonce.nom }}
      </span>
      <div class="flex md12 ma-0 pa-0">
        <va-button
          class="button-comments"
          small
          outline
          :color="annonce.nbcomments ? 'success' : 'info'"
          @click="showComments = !showComments"
        >Commentaires</va-button>
      </div>
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth kitmedia"
        color="gray"
        disabled
      >Kit Média</va-button>
    </div>
    <div class="flex md1 col-pos">
      <va-button
        class="fullwidth"
        :color="annonce.date_envoi ? 'success' : 'info'"
        @click="dispDevis()"
      >Devis
        {{
          annonce.date_envoi
            ? moment(annonce.date_envoi, "YYYY-MM-DD").format("DD/MM/YYYY")
            : ""
        }}</va-button>
    </div>
    <div class="flex md1 col-pos">{{ montantProp(annonce) }} €</div>
    <div class="flex md1 col-pos">
      {{ annonce.type === "presse" ? annonce.size + " page" : annonce.type }}
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth kitmedia"
        :color="annonce.date_validation ? 'success' : 'info'"
        @click="showUpload = true"
      >{{ validationTexte }}</va-button>
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth"
        color="gray"
        disabled
      >Visuel</va-button>
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth"
        :color="annonce.idfacture ? 'success' : 'gray'"
        @click="openFactureEditor"
      >Facture</va-button>
    </div>
    <div class="flex md1">
      <va-button
        class="fullwidth"
        :color="colorPaiement"
        @click="openPaiementEditor"
      >{{
          annonce.date_paiement
            ? "Payé le " + moment(annonce.date_paiement).format("DD/MM/YYYY")
            : "Non payé"
        }}</va-button>
    </div>
    <div class="flex md1"></div>
    <div class="flex md1"></div>
    <div class="flex md1">
      <va-popover
        placement="left "
        color="info"
        :message="attributionMessage(annonce)"
      >
        <va-button
          flat
          large
          :color="attributionColor(annonce)"
          icon="fa fa-circle"
          @click="changeAttribution()"
        />
      </va-popover>
    </div>
    <div
      class="flex md12 mb-3 mt-0 pt-0"
      v-if="showComments"
    >
      <devis-comments-list
        class="relance-container-list"
        :iddevis_publications="annonce.iddevis_publication"
        setheight="15"
      />
    </div>
    <devis-visualisation
      :iddevis="annonce.iddevis_publication"
      v-model="showVisDevis"
      v-on:modify="openEdit"
    />
    <devis-modification
      :iddevis="annonce.iddevis_publication"
      v-model="showEditDevis"
      v-on:modified="reloadList"
    />
    <upload-devis
      :iddevis="annonce.iddevis_publication"
      v-model="showUpload"
      :entrepriseName="annonce.nom"
    />
    <va-modal
      class="modal"
      v-model="showFacture"
      v-on:cancel="showFacture = false"
      :hideDefaultActions="true"
      disabled
      title="Edition facture"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <va-button
            class="fullwidth"
            color="info"
            @click="getFacture"
            :disabled="!annonce.idfacture"
            v-show="annonce.idfacture"
          >Télécharger la facture</va-button>
        </div>
        <div class="flex md6">
          <va-button
            class="fullwidth"
            color="info"
            @click="editFacture"
          >{{
              annonce.idfacture ? "Réédition de la" : "Editer la"
            }}
            facture</va-button>
        </div>

        <div class="flex md6">
          <va-date-picker
            :config="{ dateFormat: 'd-m-Y' }"
            v-model="dateFacture"
          />
        </div>
        <div class="flex md12">
          <va-button
            class="fullwidth"
            color="danger"
            @click="annulerFacture"
            :disabled="!annonce.idfacture"
            v-show="annonce.idfacture"
          >Annuler la facture</va-button>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      v-model="showDeleteConfirm"
      okText="Confirmer"
      cancelText="Annuler"
      v-on:cancel="showDeleteConfirm = false"
      v-on:ok="deleteFacture"
      title="Annulation facture"
    >
      Confirmer l'annulation de la facture?
    </va-modal>
    <va-modal
      class="modal"
      v-model="showWaiting"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <va-progress-circle
        indeterminate
        color="info"
      />
    </va-modal>
    <paiement-modal
      v-model="showPaiement"
      :idfacture="annonce.idfacture"
      @update="reloadList"
    />
  </div>
</template>

<script>
import axios from "axios";
import DevisVisualisation from "./devisVisualisation";
import DevisModification from "./devisModification";
import moment from "moment";
import DevisCommentsList from "./devisCommentsList";
import UploadDevis from "./uploadDevis";
import PaiementModal from "./paiementModal";

export default {
  name: "annonces-list-line",
  props: ["idannonce"],
  components: {
    DevisVisualisation,
    DevisModification,
    DevisCommentsList,
    UploadDevis,
    PaiementModal,
  },

  data() {
    return {
      moment: moment,
      showUpload: false,
      showComments: false,
      annonce: null,
      paid: false,
      showVisDevis: false,
      showEditDevis: false,
      showFacture: false,
      dateFacture: moment().format("DD-MM-YYYY"),
      showDeleteConfirm: false,
      showWaiting: false,
      showPaiement: false,
    };
  },
  computed: {
    validationTexte() {
      if (this.annonce.date_validation) {
        return (
          "Validé le " +
          moment(this.annonce.date_validation, "YYYY-MM-DD").format(
            "DD/MM/YYYY"
          )
        );
      } else {
        return "En attente";
      }
    },
    colorPaiement() {
      if (!this.annonce.idfacture) {
        return "gray";
      } else if (!this.annonce.date_paiement) {
        return "info";
      } else {
        return "success";
      }
    },
    partenaire_name_color() {
      if (this.annonce.isprospection) {
        return "yellow"
      }
    }
  },
  created() {
    this.getAnnonce();
  },
  mounted() { },
  methods: {
    openPaiementEditor() {
      this.showPaiement = false;
      this.showPaiement = true;
    },
    montantProp(annonce) {
      let montant = annonce.montant;
      let remise = (annonce.montant * annonce.remise) / 100;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return montant - remise - remise_fixe;
    },
    annulerFacture() {
      this.showDeleteConfirm = true;
    },
    async deleteFacture() {
      try {
        this.showWaiting = true;
        let params = { idfacture: this.annonce.idfacture };
        await axios.delete("/api/publications/facture", { params: params });
        this.launchEpicmaxToast("Facture supprimé");
        this.showFacture = false;
        this.showDeleteConfirm = false;
        this.showWaiting = false;
        this.getAnnonce();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la suppression");
        this.showWaiting = false;
      }
    },
    async getFacture() {
      try {
        this.showWaiting = true;
        let resTmp = await axios.get("/api/publications/facture", {
          params: { idfacture: this.annonce.idfacture },
        });
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la récupération de la facture");
        this.showWaiting = false;
      }
    },
    async editFacture() {
      try {
        this.showWaiting = true;
        let params = {
          idannonce: this.idannonce,
          dateFacture: moment(this.dateFacture, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
        };

        let resTmp = await axios.post("/api/publications/facture", params);
        this.getAnnonce();
        // open facture
        let url = resTmp.data.pdfurl;
        let facture_id = resTmp.data.facture_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Facture_" + facture_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Facture éditée");
        this.showFacture = false;
        this.showWaiting = false;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'édition de la facture");
        this.showWaiting = false;
      }
    },
    openFactureEditor() {
      this.showFacture = false;
      this.showFacture = true;
    },
    reloadList() {
      console.log("here");
      this.$emit("reloadList", this.idannonce);
    },
    openEdit(iddevis) {
      this.showVisDevis = false;
      this.showEditDevis = true;
    },
    dispDevis() {
      this.showEditDevis = false;
      if (!this.showVisDevis) {
        this.showVisDevis = true;
      } else {
        this.showVisDevis = false;
        this.showVisDevis = true;
      }
    },
    async changeAttribution() { },
    attributionMessage(annonce) {
      if (!annonce.idutilisateur_attribution) {
        return "Non attribué";
      }

      return annonce.nom_complet;
    },
    attributionColor(annonce) {
      if (!annonce.idutilisateur_attribution) {
        return "info";
      }
      if (
        annonce.idutilisateur_attribution ===
        this.$store.getters.user.idutilisateurs
      ) {
        return "success";
      }
      return "danger";
    },
    async getAnnonce() {
      try {
        let res = await axios.get("/api/publications/annonce", {
          params: { idannonce: this.idannonce },
        });

        this.annonce = res.data;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors du chargement de la liste des annonces"
        );
        console.log(error);
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.fullwidth {
  width: 95%;
  font-size: 0.8em;
}

.kitmedia {
  font-size: 0.8em;
}

.col-pos {
  text-align: center;
}
.centered {
  padding-left: 15%;
}

.separator-int {
  border-bottom: 1px solid #ccc;
}

.button-comments {
  margin: 5px 0;
  padding: 1px 5px;
}

.yellow {
  color: orange;
}
</style>
